import {
  ADD_FLASH_MESSAGE,
  CLEAR_FLASH_MESSAGE
} from '../actions';

const initialState = [];

export default (state = initialState, action) => {
  if (action.type === ADD_FLASH_MESSAGE) {
    return state.concat({
      message: action.payload.message,
      level: action.payload.level
    });
  }
  else if (action.type === CLEAR_FLASH_MESSAGE) {
    return state.slice(1);
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/my-events/reducers/flash-messages.js